import { FC } from 'react'
import shallow from 'zustand/shallow'
import { PerEmpty } from '../../../components/custom_components/Empty'
import { useTranslation } from 'react-i18next'
import BackgroundBox from '../../../components/custom_components/BackgroundBox'
import { useCultivatingTalentsIsEnabled } from '../../../graphql/talents-season/useRankingIsEnabled'
import { LoadingAndErrors } from '../../../components/custom_components/LoadingAndErrors'
import { CultivatingTalentsView } from './CultivatingTalentsView'
import { useHRSettingsStore } from '../hrSettings/HRSettingsStore'

export const HRSettingsCultivatingTalentsTab: FC = () => {
  const { t } = useTranslation()
  const [selected] = useHRSettingsStore((state) => [state.selected], shallow)
  const { companyId, country } = selected

  const {
    data: cultivatingTalentsData,
    error: cultivatingTalentsError,
    loading: cultivatingTalentsLoading,
  } = useCultivatingTalentsIsEnabled(companyId, country)

  if (cultivatingTalentsLoading || cultivatingTalentsError || !cultivatingTalentsData) {
    return (
      <LoadingAndErrors
        isLoading={cultivatingTalentsLoading}
        hasNoData={!cultivatingTalentsData}
        error={cultivatingTalentsError}
        showSpinner
      />
    )
  }

  return cultivatingTalentsData.isCultivatingTalentsEnabledForCompanyAndCountry ? (
    <CultivatingTalentsView
      companyId={companyId}
      country={country}
      isHRSettings={true}
      isAllCompaniesSettings={false}
      isYourCompanyView={false}
    />
  ) : (
    <BackgroundBox color="white75" r>
      <PerEmpty iconSize="m" icon="empty_stroke" heading={t('companySettingsView.rankingTab.cultivatingTalentsDisabled')} />
    </BackgroundBox>
  )
}
